module.exports = __webpack_public_path__ + "static/media/dora_iceandic.336440e2.mp3";